import AppWrapper from 'components/board/AppWrapper';
import UserSettingsForm from 'screens/settings/UserSettingsForm';
import CompanySettingsForm from 'screens/settings/CompanySettingsForm';
import ChangePasswordForm from 'screens/settings/ChangePasswordForm';
import TelematicAccountsForm from 'screens/settings/TelematicAccountsForm';
import CompanyWorkingHoursForm from 'screens/settings/CompanyWorkingHoursForm';
import MainHeader from 'components/board/MainHeader';
import MainContent from 'components/board/MainContent';
import ParkingCards from './settings/ParkingCards';
import CompanyCarSettingsForm from './settings/CompanyCarSettingsForm';
import PermissionGate from 'components/PermissionGate';
import { FormattedMessage } from 'react-intl';
import { FeatureKey } from 'myParkdUtils/enums';
import { formatMessage } from 'i18n/CurrentLocale';
import placeholders from 'string-translations/placeholders';
import * as CookieConsent from "vanilla-cookieconsent";


export const SettingsScreen = () => (
    <AppWrapper>
        <main id="page-settings" className="col-main">
            <MainHeader>
                <div className="header-v-align">
                    <h2 className="main-header-title">
                        <FormattedMessage id="GLOBAL_SETTINGS" />
                    </h2>
                </div>
            </MainHeader>

            <MainContent>
                <UserSettingsForm />
                <CompanySettingsForm />
                <CompanyWorkingHoursForm />
                <PermissionGate featureKey={FeatureKey.DRIVER_SETTINGS}>
                    <CompanyCarSettingsForm />
                </PermissionGate>
                <ChangePasswordForm />
                <TelematicAccountsForm />
                <PermissionGate featureKey={FeatureKey.PARKD_CARDS}>
                    <ParkingCards />
                </PermissionGate>

                <div id='footer-links'>
                    <span>© 2026 Parkd. <FormattedMessage id="GLOBAL_COPYRIGHT" /></span>
                    <a className='clickable-link' href={formatMessage(placeholders.parkdTermsConditionsURL)} target="_blank" rel="noreferrer">
                        <FormattedMessage id="REGISTRATION_TERMS_AND_CONDITIONS" />
                    </a>
                    <span className='clickable-link' onClick={() => CookieConsent.showPreferences()}>
                        <FormattedMessage id="COOKIE_CONSENT_PREFERENCES_MODAL_TITLE" />
                    </span>
                </div>

            </MainContent>
        </main>
    </AppWrapper>
);

export default SettingsScreen;